/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
  Martin vicencio
  Benko hanck
==========================================================================================*/
export default [
  {
    
        url: null,
    name: "Mi Perfil",
    slug: "Mi Perfil",
    icon: "UserIcon",
    i18n: "Mi Perfil",
    submenu: [
      {
        url: '/administrativos/datos_user',
        name: "AlumnosCe",
        slug: "AlumnosCe",
        i18n: "Perfil",
      },
      // {
      //   url: '/pages/profile',
      //   name: "pageProfile",
      //   slug: "pageProfile",
      //   i18n: "pruebas",
      // },


     ]
  },
  {
    url: null,
    name: "Control escolar",
    slug: "ControlEscolar",
    icon: "SlidersIcon",
    i18n: "Control escolar",
    submenu: [
      {
        url: '/administrativos/alumnos',
        name: "AlumnosCe",
        slug: "AlumnosCe",
        i18n: "Alumnos",
      },
      {
        url: '/administrativos/alum_activos',
        name: "AlumnosAC",
        slug: "AlumnosAC",
        i18n: "AlumnosActivos",
      },
     
      {
        url: '/administrativos/estatus_academico',
        name: "estatus_academico",
        slug: "estatus_academico",
        i18n: "Estatus Academico",
      },
      {
        url: '/administrativos/estadisticas',
        name: "EstadisticasCe",
        slug: "EstadisticasCe",
        i18n: "Estadisticas",
      },

    ]
  },


  {
    url: null,
    name: "Admision",
    slug: "Admision",
    icon: "MonitorIcon",
    i18n: "Admision",
    submenu: [
      {
        url: '/administrativos/aspirantes',
        name: "Aspirantes",
        slug: "Aspirantes",
        i18n: "Aspirantes",
      },

      {
        url: '/administrativos/documentos_aspirantes',
        name: "Documentos Aspirantes",
        slug: "Documentos Aspirantes",
        i18n: "Documentos Aspirantes",
      },

    ]
  },
//Inscripcion
  {
    url: null,
    name: "Inscripcion",
    slug: "Inscripcion",
    icon: "CheckSquareIcon",
    i18n: "Inscripcion",
    submenu: [
     
      {
        url: '/administrativos/fechas_aspirantes',
        name: "Fechas Aspirantes",
        slug: "Fechas Aspirantes",
        i18n: "Fechas Aspirantes",
      },
      {
        url: '/administrativos/validar_documentos_aceptados',
        name: "ValidarDocAceptados",
        slug: "ValidarDocAceptados",
        i18n: "ValidarDocAceptados",
      },
      {
        url: '/administrativos/ver_pagos_inscripcion',
        name: "VerPagosInscripcion",
        slug: "VerPagosInscripcion",
        i18n: "VerPagosInscripcion",
      },
      {
        url: '/administrativos/generar_matriculas',
        name: "generar_matriculas",
        slug: "generar_matriculas",
        i18n: "Generar Matriculas",
      },      
      
      {
        url: '/administrativos/descargar_documentos_validados_inscripcion',
        name: "descargar_documentos_validados_inscripcion",
        slug: "descargar_documentos_validados_inscripcion",
        i18n: "DescargarDocumentosValidadosInscripcion",
      }  

    ]
  },

  {
    url: null,
    name: "Servicios Finanacieros",
    slug: "ServiciosFinancieros",
    icon: "PieChartIcon",
    i18n: "Finanzas",
    submenu: [
      {
        url: '/administrativos/pagos_internos',
        name: "pagos_internos",
        slug: "pagos_internos",
        i18n: "Pagos Internos",
      },
      {
        url: '/administrativos/pagos_reinscripciones',
        name: "pagos_reinscripciones",
        slug: "pagos_reinscripciones",
        i18n: "Pagos Reinscripciones",
        // tag:"New",
        // tagColor:"green",
      },
      {
        url: '/administrativos/periodos_pagos_re_inscripcion',
        name: "periodos_pagos_re_inscripcion",
        slug: "periodos_pagos_re_inscripcion",
        i18n: "PeriodosPagReinscripcion",
        tag:"New",
        tagColor:"green",
      },
      {
        url: '/administrativos/pagos_externos',
        name: "pagos_externos",
        slug: "pagos_externos",
        i18n: "Pagos Externos"
         },
      {
        url: '/administrativos/pagos_admision',
        name: "pagos_admision",
        slug: "pagos_admision",
        i18n: "PagosFichaAdmisión"
      },
      {
        url: '/administrativos/pagos_isseg',
        name: "pagos_isseg",
        slug: "pagos_isseg",
        i18n: "Pagos Isseg"
      },
    ]
  },
  {
    url: null,
    name: "Calendario Escolar",
    slug: "alumnos",
    icon: "CalendarIcon",
    i18n: "Calendario Escolar",
    submenu: [
      {
        url: '/alumnos/calendarioescolar',
        name: "Calendario Escolar",
        slug: "calendarioEscolar",
        i18n: "Calendario Escolar",
      },

    ]
  },

  // {
  //   url: null,
  //   name: "Cuatrimestre Actual",
  //   slug: "cuatrimestreActual",
  //   icon: "",
  //   i18n: "Cuatrimestre Actual",
  //   submenu: [
  //     {
  //       url: '/directores/grupos',
  //       name: "Grupos",
  //       slug: "grupos",
  //       i18n: "Grupos",
  //     },
  //     {
  //       url: '/directores/alumnos',
  //       name: "Alumnos",
  //       slug: "alumnos",
  //       i18n: "Alumnos",
  //     }      
  //   ]
  // },
  {
    url: null,
    name: "Catálogos",
    slug: "catalogos",
    icon: "BookIcon",
    i18n: "Catálogos",
    submenu: [
      {
        url: '/administrativos/cat_profesores',
        name: "CatProfesores",
        slug: "CatProfesores",
        i18n: "Profesores"
      },
      {
        url: '/administrativos/cat_administrativos',
        name: "CatAdministrativos",
        slug: "CatAdministrativos",
        i18n: "Administrativos"
      },
      {
        url: '/administrativos/parametros_fechas',
        name: "parametros_fechas",
        slug: "parametros_fechas",
        i18n: "Fechas Calendario Escolar"
      }

    ]
  },
  {
    url: null,
    name: "Grupos",
    slug: "Grupos",
    icon: "UsersIcon",
    i18n: "Grupos",
    submenu: [
      {
        url: '/administrativos/generar_grupos',
        name: "GenerarGrupos",
        slug: "GenerarGrupos",
        i18n: "GenerarGrupos",
        // tag:"New",
        // tagColor:"green"
       },
      {
    url: '/administrativos/otrosgrupos',
    name: "GruposCalificaciones",
    slug: "GruposCalificaciones",
    i18n: "CalificacionesGrupos"
   },
    {
     url: '/administrativos/grupos_estanciasyestadias',
     name: "GruposEstanciasYEstadias",
     slug: "GruposEstanciasYEstadias",
     i18n: "GruposEstanciasYEstadia",
     tag:"New",
     tagColor:"green"
      },
      {
        url: '/administrativos/grupos_competencias',
        name: "GruposCompetencias",
        slug: "GruposCompetencias",
        i18n: "GruposCompetencias",
        tag:"New",
        tagColor:"green"

         }
       ]
 }

]


